import { render, staticRenderFns } from "./feature1.vue?vue&type=template&id=6c616e9a&scoped=true"
import script from "./feature1.vue?vue&type=script&lang=js"
export * from "./feature1.vue?vue&type=script&lang=js"
import style0 from "./feature1.vue?vue&type=style&index=0&id=6c616e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c616e9a",
  null
  
)

export default component.exports